import React from 'react'

const Loader = () => (
  <span className="loader"><span></span></span>
)

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.jsx